import { render, staticRenderFns } from "./RegisterUserCard.vue?vue&type=template&id=30a3641c"
import script from "./RegisterUserCard.vue?vue&type=script&lang=js"
export * from "./RegisterUserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports